import { Route, Switch, useRouteMatch } from 'react-router-dom'

import { PrivateRoute } from 'core/ui/components/private-route/PrivateRoute'
import { useAuthContext } from 'core/ui/contexts/authContext'

import { PageWrapper } from 'legacy/components/PageWrapper/PageWrapper'
import { LoadBoardContextProvider } from 'legacy/contexts/loadBoard'

import { ConfigProvider } from 'config/ui/ConfigContext'
import { BookConfirmation } from 'loads/ui/book-confirmation/BookConfirmation'
import { LoadSetupPage } from 'loads/ui/load-setup/LoadSetupPage'
import { RMISOnboarding } from 'loads/ui/rmis-onboarding/RMISOnboarding'
import { SuggestedPreferredLanesProvider } from 'preferred-lanes/ui/context/suggestedPreferredLanesContext'

import { AppSuggestion } from './AppSuggestion/AppSuggestion'
import { BidManager } from './BidManager/BidManager'
import { CarrierManager } from './CarrierManager/CarrierManager'
import { LoadBoard } from './LoadBoard/LoadBoard'
import { TopOffersProvider } from './LoadBoard/TopOffers/TopOffersContext'
import { LoadDetails } from './LoadDetails/LoadDetails'
import { Notifications } from './Notifications/Notifications'

export default function LoadsPage() {
  const { path } = useRouteMatch()
  const [userToken] = useAuthContext()

  const isLogged = Boolean(userToken)

  return (
    <PageWrapper>
      <LoadBoardContextProvider>
        <TopOffersProvider>
          <SuggestedPreferredLanesProvider>
            <ConfigProvider>
              <CarrierManager>
                <Notifications />
                <Switch>
                  <PrivateRoute path={`${path}/`} component={LoadBoard} exact />
                  <PrivateRoute
                    path={`${path}/:loadUUID/setup`}
                    component={LoadSetupPage}
                    entitiesNotAllowed={['broker']}
                    exact
                  />
                  <Route path={`${path}/:loadUUID`} component={LoadDetails} exact />
                </Switch>
                {isLogged && (
                  <>
                    <BookConfirmation />
                    <RMISOnboarding />
                    <BidManager />
                  </>
                )}
                <AppSuggestion />
              </CarrierManager>
            </ConfigProvider>
          </SuggestedPreferredLanesProvider>
        </TopOffersProvider>
      </LoadBoardContextProvider>
    </PageWrapper>
  )
}
